import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";

const RoleSelectWrapper = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontFamily: "sans-serif",
}));

const RoleLabel = styled.span(() => ({
  fontWeight: 500,
  fontSize: "14px",
}));

const RoleDropdown = styled.div(() => ({
  position: "relative",
}));

const DropdownButton = styled.button(() => ({
  backgroundColor: "#444d4e",
  color: "white",
  border: "none",
  borderRadius: "999px",
  padding: "6px 15px",
  fontSize: "14px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "6px",
}));

const Arrow = styled.span(() => ({
  fontSize: "10px",
}));

const DropdownMenu = styled.div(() => ({
  position: "absolute",
  top: "110%",
  right: 0,
  background: "white",
  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  borderRadius: "10px",
  overflow: "hidden",
  minWidth: "fit-content",
  zIndex: 1000,
}));

const DropdownItem = styled.div(() => ({
  padding: "10px",
  fontSize: "12px",
  cursor: "pointer",
  textAlign: "center",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
}));

const RoleSelect = ({ options, onChange, defaultValue }: any) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<{
    label: string;
    value: string;
  } | null>(options.find((i) => i.value === defaultValue) || null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setOpen(!open);
  const handleSelect = (value) => {
    if (onChange) {
      onChange(value);
    }
    setSelected(value);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <RoleSelectWrapper>
      <RoleDropdown ref={dropdownRef}>
        <DropdownButton onClick={toggleDropdown}>
          {selected ? selected.label : "-"} <Arrow>▾</Arrow>
        </DropdownButton>
        {open && (
          <DropdownMenu>
            {options.map((i) => (
              <DropdownItem onClick={() => handleSelect(i)}>
                {i.label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        )}
      </RoleDropdown>
    </RoleSelectWrapper>
  );
};

export default RoleSelect;
